class Utils {
  static getErrorMessage(err) {
    let error = "Oops...something went wrong.";
    if (err.response && err.response.data) {
      if (err.response.data.message) {
        error = err.response.data.message;
      }
    } else if (err.message) {
      error = err.message;
    }
    return error;
  }

  static priceNumberFormat(price) {
    if(!price) return '';
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(price);
  }
}

export default Utils;
